import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { Form, InputGroup, Col, Row, Button, FloatingLabel } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';
import DBService from '../../service/DBService';
import ScreenerSelect from './ScreenerSelect';
//import ATSShowDetails from './ATSShowDetails';
import '../../css/ATSListDisplay.css';
import { getCookie } from '../../service/Cookie';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Filter" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "transaction",
        text: "Transaction",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }
    },
    {
        dataField: "shares",
        text: "Shares",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    // {
    //     dataField: "",
    //     text: "Details",
    //     sort: false,
    //     formatter: (cell, row) => <i className={'fa fa-file-text'} style={{ height: '10px', width: '10px', cursor: 'pointer' }}></i>,
    //     headerStyle: { fontSize: '10px', width: '50px' },
    //     style: (cell, row, rowIndex, colIndex) => {
    //         return {
    //             textAlign: 'center'
    //         }
    //     },
    // },
];


const columns = [
    {
        dataField: "symbol",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "transaction",
        text: "Transaction",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "transactionDate",
        text: "Date",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "shares",
        text: "Shares",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "price",
        text: "Price",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        editable: false
    },
    {
        dataField: "",
        text: "Delete",
        sort: false,
        //formatter: (cell, row) => <i className={'fa fa-file-text'} style={{ height: '10px', width: '10px', cursor: 'pointer' }}></i>,
        headerStyle: { fontSize: '10px', width: '80px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'center',
            }
        },
        formatter: (cellContent, row) => {
            return (
              <Button
                //className="btn btn-danger btn-xs"
                onClick={() => handleDelete(row.id, row.name)}
                variant="danger"
                size="sm"
              >
                Delete
              </Button>
            );
        },
        editable: false
     
    },

];

const handleDelete = (rowId, rowName) => {
    console.log(rowId, rowName);
  };

// const expandRow = {
//     onlyOneExpanding: true,
//     parentClassName: 'my-parent-expand-foo',
//     showExpandColumn: true,
//     renderer: row => (
//         <ATSShowDetails week={row.lastUpdateDate} symbol={row.issueSymbolIdentifier} />
//     )
// };

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class PortfolioListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbol: this.props.symbol,
            atsWeeklyList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: '',
            weeklyOptions: [],
        };
        console.log('ATSListDisplay props', this.props, this.state.symbol);
    }

    componentDidMount() {
        this.getData();
    }

    getUserId() {
        let userId = '';
        let cookieValue = getCookie();
        if (cookieValue !== undefined && cookieValue.userId !== undefined) {
            console.log('Setting userId', cookieValue.userId);
            userId = cookieValue.userId;
        }
        return userId;
    }

    getData() {
        let body = {
            userId: this.getUserId()
        }
        DBService.userPortfolioDistincName(body)
            .then(result => {
                console.log('userPortfolioDistincNames', result);
                if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                    result = result.data;
                    let tmpOptions = [];
                    for (var i = 0; i < result.length; i++) {
                        if (i === 0) {
                            tmpOptions.push({ "labelKey": { criteria: 'weekly', value: result[i].name }, "value": result[i].name, "isSelected": true });
                        } else {
                            tmpOptions.push({ "labelKey": { criteria: 'weekly', value: result[i].name }, "value": result[i].name });
                        }
                    }
                    this.setState({ weeklyOptions: tmpOptions, reload: true });
                    console.log('ats weeklyOptions', tmpOptions, tmpOptions[0].value);
                    let body1 = {
                        userId: this.getUserId(),
                        name: tmpOptions[0].value
                    }
                    DBService.userPortfolio(body1)
                        .then(result => {
                            console.log('ats getAtsWeeklyTotal', result);
                            if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                                result = result.data;
                                this.setState({ weeklyOptions: tmpOptions, atsWeeklyList: result, reload: true });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    selectUpdateObj(selectedOptions) {
        let tmpObj = {
            selectedKey: [
                JSON.parse(selectedOptions.target.value)
            ],
            selectedValue: []
        }
        return tmpObj;
    }

    handleWeeklyChange = (selectedOptions) => {
        this.selectedWeekly = this.selectUpdateObj(selectedOptions);
        console.log('ats Screen Criteria -selected weekly', this.selectedWeekly, selectedOptions);
        const key = this.selectedWeekly.selectedKey[0];
        let body = {
            userId: 'vasudel@yahoo.com',
            name: key.value
        }
        DBService.userPortfolio(body)
            .then(result => {
                console.log('ats getAtsWeeklyTotal', result);
                if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                    result = result.data;
                    this.setState({ atsWeeklyList: result });
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }

    addNewRow = () => {
        let tmp = {
            id: 17,
            name: "Longterm",
            price: 100,
            shares: 1,
            symbol: "AAPL1",
            transaction: "Buy",
            transactionDate: "2022-02-11",
            userId: "vasudel@yahoo.com"};
        console.log('addnew', tmp);
        this.setState({ atsWeeklyList: [...this.state.atsWeeklyList, tmp] });
    }

    addNewProfile=()=>{
        console.log('New Profile');
    }


    save=()=> {
        console.log('save', this.state.atsWeeklyList);
    }



    render() {
        if (this.state.reload) {
            console.log('ATSListDisplay Reloading...');
            this.setState({ reload: false });
            return (<div>Loading...</div>);
        }

        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="issueSymbolIdentifier"
                        data={this.state.atsWeeklyList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>  <Row>
                                    <Col xs="6" md="3" lg="3" xl="3">
                                        <ScreenerSelect options={this.state.weeklyOptions} onChange={this.handleWeeklyChange} label={'Name'} />
                                    </Col>

                                    <Col xs="6" md="6" lg="6" xl="6"> 
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="New Portfolio Name"
                                            key="name"
                                            className="mb-3"
                                        >
                                            <Form.Control type="name" placeholder="Portfolio Name" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
                                        </FloatingLabel>
                                        
                                    </Col>
                                    <Col xs="4" md="2" lg="2" xl="1">
                                        <Button variant="primary" onClick={this.addNewProfile}>Add New Portfolio</Button>
                                    </Col>
                                    <Col xs="4" md="2" lg="2" xl="1">
                                        <Button variant="primary" onClick={this.addNewRow}>Add New Row</Button>
                                    </Col>
                                    <Col xs="4" md="2" lg="2" xl="1">
                                        <Button variant="success" onClick={this.save}>Save</Button>
                                    </Col>
                                </Row>
                                    <Row>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        //expandRow={expandRow}
                                        pagination={paginationFactory(options)}
                                        cellEdit={ cellEditFactory({
                                            mode: 'click',
                                            blurToSave: true,
                                            autoSelectText: true
                                          }) } 
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="issueSymbolIdentifier"
                        data={this.state.atsWeeklyList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>  <Row>
                                    <Col xs="6" md="3" lg="3" xl="3">
                                        <ScreenerSelect options={this.state.weeklyOptions} onChange={this.handleWeeklyChange} label={'Name'} />
                                    </Col>

                                    <Col xs="6" md="3" lg="3" xl="3"> 
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="New Portfolio Name"
                                            key="name"
                                            className="mb-3"
                                        >
                                            <Form.Control type="name" placeholder="Portfolio Name" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
                                        </FloatingLabel>
                                        
                                    </Col>
                                    <Col >
                                        <Button variant="primary" onClick={this.addNewProfile}>Add New Portfolio</Button>
                                    </Col>
                                    <Col>
                                        <Button variant="primary" onClick={this.addNewRow}>Add New Row</Button>
                                    </Col>
                                    <Col>
                                        <Button variant="success" onClick={this.save}>Save</Button>
                                    </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        //expandRow={expandRow}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default PortfolioListDisplay;
